module.exports = __webpack_public_path__ + "img/union.6868055d.svg";